import { render, staticRenderFns } from "./saveTeacher.vue?vue&type=template&id=2b944f41&"
import script from "./saveTeacher.vue?vue&type=script&lang=js&"
export * from "./saveTeacher.vue?vue&type=script&lang=js&"
import style0 from "./saveTeacher.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports